import { useNavigate } from "react-router-dom";
import NavButton from "../buttons/NavButton";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { getSelected } from "../utils/nbutils";

const TopMenu = ({location, navmethod}) => {
    const navigate = useNavigate();

    const loc = useLocation();
    const [active, setActive] = useState("/");

    const ue = useEffect(() => {
        setActive(getSelected(loc.pathname, "first"));
    }, [loc])

    const navClass = () => {
        const navpos = location === ("" || "/") ? "" : ""
        return `top_nav${navpos}`;
    }

    const navNames = [
        'writing', 'tech', 'design', 'press', 'contact'
    ];

    const navFunction = (dest) => {
        navmethod(dest);
        setActive(dest);
        navigate(dest);
    }

    //console.log("topMenu", active);

    return(
        <div className={navClass()}>
            {navNames.map((namefa) => {
                return (
                    <NavButton 
                        name={namefa} 
                        key={namefa}
                        active={(!!(active === `${namefa}`))}
                        navfunc={navFunction}
                        />
                )
            })}
        </div>
    )
}

export default TopMenu;

//  